import _ from "lodash";

export function buildNameField(value) {
    return buildTextField({
        label: "Name",
        value,
        required: true,
    });
}

function emptyValidationRule({ label, value }) {
    if (_.isEmpty(value)) {
        return `${label} is required`;
    } else {
        return true;
    }
}

function buildValidationRules({ label, required }) {
    if (!required) {
        return [];
    } else {
        return [(value) => emptyValidationRule({ label, value })];
    }
}

export function buildTextField({ label, value, type = "text", required = false }) {
    const validationRules = buildValidationRules({ label, required });
    return {
        fieldType: "text",
        fieldDisplayName: label,
        value: value,
        validationRules,
    };
}

export function buildNumberField({ label, value, required = false }) {
    return buildTextField({
        label,
        value,
        type: "number",
        required,
    });
}

export function buildSelectField(config) {
    const { name, options, value, changed } = config;
    return {
        fieldType: "select",
        fieldDisplayName: name,
        options: options,
        value: value,
        validationRules: [],
        changed: changed,
    };
}

export function buildMultiSelectField(config) {
    const { name, options, values, changed } = config;
    return {
        fieldType: "multiselect",
        fieldDisplayName: name,
        options: options,
        values: values,
        validationRules: [],
        changed: (option, formField) => {
            if (changed) changed(option, formField);
        },
    };
}

export function buildSlotField({ slot, cols }) {
    return {
        fieldType: "slot",
        slot,
        cols,
    };
}
